import { SVGAttributes } from "react";

const LaunchIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="2.66675"
        width="20"
        height="26.6667"
        rx="6"
        stroke="#CFB2FF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66699 8.5H16.3337"
        stroke="#FFA686"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LaunchIcon;
